import React, { useState } from 'react';
const faqs = [{
  question: '¿Para qué edad es este programa?',
  answer: 'Está diseñado idealmente para niños entre 4 y 9 años que están iniciando el proceso o que han tenido dificultades iniciales. Sin embargo, los principios funcionan para cualquier niño que necesite reforzar las bases fonológicas.'
}, {
  question: '¿Necesito ser maestra para aplicarlo?',
  answer: 'No. El manual te guía paso a paso con instrucciones claras y simples. Está diseñado especialmente para padres sin formación docente. Si sabés leer y tenés 10 minutos al día, podés aplicarlo.'
}, {
  question: '¿Cuánto tiempo necesito por día?',
  answer: 'Solo 10 minutos diarios. El sistema está diseñado para ser breve y efectivo. La constancia vale más que la duración.'
}, {
  question: '¿Es digital o me llega algo a casa?',
  answer: 'Es 100% digital. Recibís acceso inmediato por email a todos los materiales. Los workbooks y actividades son imprimibles, así que podés tenerlos en papel si preferís.'
}, {
  question: '¿Qué pasa si mi hijo ya sabe algunas letras?',
  answer: 'Funciona igual, y en muchos casos mejor. El programa refuerza las bases que quizás se saltaron. Muchos niños que "saben letras" pero no avanzan tienen exactamente el problema de activación que este sistema resuelve.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 px-5 bg-cream text-center reveal" data-id="element-91">
      <h2 className="font-playfair text-[clamp(1.8rem,3.5vw,2.6rem)] font-bold text-text-dark mb-3.5 leading-[1.2]" data-id="element-92">
        Preguntas frecuentes
      </h2>
      <p className="font-lora text-base text-text-mid max-w-[500px] mx-auto mb-10 leading-relaxed italic" data-id="element-93">
        Respuestas rápidas a las dudas más comunes antes de comprar.
      </p>

      <div className="max-w-[620px] mx-auto" data-id="element-94">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return <div key={index} className="border-b border-forest/10 text-left overflow-hidden" data-id="element-95">
              <button className="w-full py-5 text-[0.95rem] font-medium text-text-dark cursor-pointer flex justify-between items-center gap-3 select-none bg-transparent border-none font-sans text-left" onClick={() => toggleFaq(index)} data-id="element-96">
                {faq.question}
                <span className={`text-forest text-[1.2rem] shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} data-id="element-97">
                  +
                </span>
              </button>
              <div className={`transition-[max-height] duration-350 ease-in-out overflow-hidden text-[0.88rem] text-text-mid leading-[1.7] pr-6 ${isOpen ? 'max-h-[200px]' : 'max-h-0'}`} data-id="element-98">
                <div className="pb-5" data-id="element-99">{faq.answer}</div>
              </div>
            </div>;
      })}
      </div>
    </section>;
}